import { render } from "./ApprovalDiffPanel.vue?vue&type=template&id=8b7b9506&scoped=true"
import script from "./ApprovalDiffPanel.vue?vue&type=script&lang=js"
export * from "./ApprovalDiffPanel.vue?vue&type=script&lang=js"

import "./ApprovalDiffPanel.vue?vue&type=style&index=0&id=8b7b9506&scoped=true&lang=css"
import "./ApprovalDiffPanel.vue?vue&type=style&index=1&id=8b7b9506&lang=css"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b7b9506"],['__file',"ApprovalDiffPanel.vue"]])

export default __exports__